import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import {FindBySlug} from "@hooks/FindTranslate"
import Truncate from "@hooks/Truncate"
import {FormatCustomerStory} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKey"
import {
	CustomerStoryModuleType,
	MetaModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import customerStories from "@jsons/customerStories.json"
import CustomerStoryPost from "@pages/CustomerStories/CustomerStoryPost/CustomerStoryPost"
import Error from "next/error"
import React from "react"

type Props = {
	locale: string
	article: string
	result: CustomerStoryModuleType
}

const CustomerStory = (props: Props): JSX.Element => {
	// Trow 404 page for unExist pages
	// ! Required for avoiding errors on server side rendering
	if (!props.result) {
		return <Error statusCode={404} />
	}
	function removeHTMLFromString(input: string): string {
		// Regular expression to match HTML tags and their contents
		const regex = /<[^>]+>/g
		return input.replace(regex, "")
	}

	const description = Truncate(removeHTMLFromString(props.result.content), 60)

	const metadata: MetaModuleType = {
		title: props.result.title,
		description: description || "",
		keywords: "",
		author: "Dream Broker",
		ogTitle: props.result.title,
		ogType: "article",
		ogDescription: description || "",
		ogImage: props.result.preview.src ?? "/DB.jpg",
	}

	return (
		<>
			<HeadMeta meta={metadata} />

			<CustomerStoryPost article={props.article} data={props.result} />
		</>
	)
}

/**
 * Create Static Link paths list for creating Static Pages
 * ! Required for avoiding errors on server side rendering
 */
export const getStaticPaths = async ({locales}: {locales: any}) => {
	// Creating empty paths array
	const paths: any[] = []

	// Taking Data from Blog Posts JSON
	customerStories.entries.forEach((block) => {
		// Creating loop for creating paths for all Locales
		// ! Required for avoiding errors on server side rendering
		for (const locale of locales) {
			paths.push({
				params: {
					customerStory: block.slug,
				},
				locale,
			})
		}
	})

	return {
		paths,
		fallback: false,
	}
}

/**
 * Create Static Props for preMade Links Paths to create a static Pages
 * ! Required for avoiding errors on server side rendering
 */
export const getStaticProps = async (context: {
	params: {customerStory: string}
	locale: string
}) => {
	// Defining blog and locale const
	const article = context.params.customerStory
	const locale = context.locale

	// Find right Blog Post Data from Blog Posts json by Slug
	const translated = FindBySlug(
		customerStories.entries,
		context.locale,
		context.params.customerStory,
	)

	// Formate Single Blog Post data for Single Blog Post Page
	const result = FormatCustomerStory(translated)

	return {
		props: {article, locale, result},
	}
}

export default CustomerStory
